

class bodyFatCal extends HTMLElement {
    constructor() {
        super();
        this.form = this.querySelector('form');
        //Form Submit Event
        this.form?.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.form?.querySelector('[type="submit"]').addEventListener('click', this._checkValidation.bind(this));

        this.fatResults=Utility.getLocalStorage('fatData');
        if (window.location.href.includes('results-body-fat-calculator')) {
            if (this.fatResults) {
                this._renderResult();
            }else{
                window.location.href="/pages/zone-body-fat-calculator";
            }
        }
        
        this.querySelectorAll('[data-form-gender]').forEach((ele)=>{
            ele.addEventListener('click',(event)=>{
                event.preventDefault();
                let gender=event.target.getAttribute('data-form-gender');
                document.querySelectorAll('body-fat-calculator').forEach((ele)=>{
                    ele.classList.add('d-none')
                })
                document.querySelector(`[data-gender="${gender}"]`).classList.remove('d-none');
            })
        })
        
    }

    onSubmitHandler(event) {
        event.preventDefault();
        let gender=this.closest('[data-gender]').getAttribute('data-gender');
        if (gender == 'female') {
            this.fatData={
                gender: gender,
                weight: this.querySelector('[name="weight-1"]').value,
                height: this.querySelector('[name="height-1"]').value,
                abdomen: this.querySelector('[name="abdomen-1"]').value,
                hips: this.querySelector('[name="hips-1"]').value,
                age: parseInt(this.querySelector('[name="age-1"]').value),
                activity: this.querySelector('[name="activity-1"]').value
            }
        }else{
            this.fatData={
                gender: gender,
                weight: this.querySelector('[name="weight-2"]').value,
                height: this.querySelector('[name="height-2"]').value,
                waist: this.querySelector('[name="waist-2"]').value,
                wrist: this.querySelector('[name="wrist-2"]').value,
                age: parseInt(this.querySelector('[name="age-2"]').value),
                activity: this.querySelector('[name="activity-2"]').value
            }
        }
        
        if (this.fatData.gender == 'male') {
            this._calculateMaleFat();
        }else{
            this._calculateFemaleFat();
        }

    }

    _calculateFemaleFat=()=>{
        let weight = parseFloat(this.fatData.weight);
        weight = weight / 10;
        weight = weight * 2;
        weight = Math.round(weight);
        weight = weight / 2;
        weight = parseInt(weight * 10);
        let height = Math.abs(parseFloat(this.fatData.height));
        let abdomen = Math.abs(parseFloat(this.fatData.abdomen));
        let hips = parseFloat(this.fatData.hips)
        let bodyFatPercent = this._get_female_body_fat_percent(hips, abdomen, height);
        if (bodyFatPercent == 0) {
            bodyFatPercent = 50;
        }
        let bodyFatWeight = Math.abs((bodyFatPercent / 100) * weight);
        let leanBodyMass = Math.abs(weight - bodyFatWeight);

        let activityFactor = this._findActivityFector(this.fatData.activity,this.fatData.age);

        let dailyProtein = leanBodyMass * activityFactor
        if (dailyProtein < 77) {
            dailyProtein = 77;
        }

        let zone_blocks = parseInt(Math.round(dailyProtein) / 7);
        this.fatResults={
            bodyFatPercent: bodyFatPercent.toFixed(2),
            bodyFatWeight: bodyFatWeight.toFixed(2),
            leanBodyMass: leanBodyMass.toFixed(2),
            dailyProtein: dailyProtein.toFixed(2),
            zone_blocks: zone_blocks
        }
        Utility.setLocalStorage('fatData',JSON.stringify(this.fatResults));
        window.location.href="/pages/results-body-fat-calculator"

    }

    _calculateMaleFat=()=>{
        let weight = parseFloat(this.fatData.weight);
        weight = weight / 10;
        weight = weight * 2;
        weight = Math.round(weight);
        weight = weight / 2;
        weight = parseInt(weight * 10);
      
        let height = Math.round(parseFloat(this.fatData.height) * 2) / 2;
        let waist = Math.round(parseFloat(this.fatData.waist) * 2) / 2;
        let wrist = Math.round(parseFloat(this.fatData.wrist) * 2) / 2;

      
        let bodyFatPercent = this._getMaleBodyFatPercent(weight, (waist - wrist));
        if (bodyFatPercent == 0) {
          bodyFatPercent = 50;
        }

        let bodyFatWeight = Math.round(((parseFloat(bodyFatPercent) / 100) * weight) * 100) / 100;
        let leanBodyMass = weight - bodyFatWeight;

        let activityFactor = this._findActivityFector(this.fatData.activity,this.fatData.age);
        

        let dailyProtein = leanBodyMass * activityFactor;
        if (dailyProtein < 98) {
          dailyProtein = 98;
        }
        let zone_blocks = Math.floor(dailyProtein / 7);
        

        this.fatResults={
            bodyFatPercent,
            bodyFatWeight,
            leanBodyMass,
            dailyProtein,
            zone_blocks
        }
        Utility.setLocalStorage('fatData',JSON.stringify(this.fatResults));
        window.location.href="/pages/results-body-fat-calculator"
    }

    _findActivityFector=(activity,age)=>{
        if (activity == "Sedentary") {
            if (age < 65) {
                return 0.5
            }else{
                return 0.55
            }
        }else if(activity == "Light activity or obese"){
            if (age < 65) {
                return 0.6
            }else{
                return 0.66
            } 
        }else if(activity == "Moderate aerobic activity (3x per week)"){
            if (age < 65) {
                return 0.7
            }else{
                return 0.75
            } 
        }else if(activity == "Daily aerobic activity or moderate weight training"){
            if (age < 65) {
                return 0.8
            }else{
                return 0.9
            } 
        }else if(activity == "Very active-Daily weight training"){
            if (age < 65) {
                return 0.9
            }else{
                return 1.0
            } 
        }else if(activity == "Elite athlete"){
            if (age < 65) {
                return 1.0
            }else{
                return 1.1
            } 
        }

    }
    _renderResult=()=>{
        this.fatResults=JSON.parse(this.fatResults);
        let circularProgress = document.querySelector(".circular-progress");
        let fillProgress = document.querySelector(".fill-circular");
        let progressvalue = document.querySelector("[data-fat-percent]");
        let progressStartValue = 0.0, progressEndvalue = parseFloat(this.fatResults.bodyFatPercent), speed = 10;
        let progress = setInterval(() => {
            progressStartValue++;
            progressvalue.textContent = `${progressStartValue}`
            circularProgress.style.background = `conic-gradient(#FFDA27  ${progressStartValue * 3.6}deg, #ededed 0deg)`
            fillProgress.style.transform = `rotate(${progressStartValue * 3.6}deg) translate(-50%)`
            if (parseFloat(progressStartValue) > parseFloat(progressEndvalue)) {
                progressvalue.textContent = `${progressEndvalue.toFixed(2)}`
                clearInterval (progress);
            }
        }, speed);
        this.querySelector('[data-fat-percent]').innerHTML=parseFloat(this.fatResults.bodyFatPercent).toFixed(2);
        this.querySelector('[data-body-fat]').innerHTML=parseFloat(this.fatResults.bodyFatWeight).toFixed(2) + ' lbs';
        this.querySelector('[data-body-mass]').innerHTML=parseFloat(this.fatResults.leanBodyMass).toFixed(2) + ' lbs';
        this.querySelector('[data-body-protein]').innerHTML=parseFloat(this.fatResults.dailyProtein) + ' g';
        this.querySelector('[data-protein-blocks]').innerHTML=this.fatResults.zone_blocks;
        this.querySelector('[data-carbohydrate-blocks]').innerHTML=this.fatResults.zone_blocks;
        this.querySelector('[data-fat-blocks]').innerHTML=this.fatResults.zone_blocks;
    }

    _get_female_body_fat_percent(hips, abdomen, height) {
        const hips_table = {
            30 : 33.48,
            30.5 : 33.83,
            31 : 34.87,
            31.5 : 35.22,
            32 : 36.27,
            32.5 : 36.62,
            33 : 37.67,
            33.5 : 38.02,
            34 : 39.06,
            34.5 : 39.41,
            35 : 40.46,
            35.5 : 40.81,
            36 : 41.86,
            36.5 : 42.21,
            37 : 43.25,
            37.5 : 43.6,
            38 : 44.65,
            38.5 : 45.32,
            39 : 46.05,
            39.5 : 46.4,
            40 : 47.44,
            40.5 : 47.79,
            41 : 48.84,
            41.5 : 49.19,
            42 : 50.24,
            42.5 : 50.59,
            43 : 51.64,
            43.5 : 51.99,
            44 : 53.03,
            44.5 : 53.41,
            45 : 54.53,
            45.5 : 54.86,
            46 : 55.83,
            46.5 : 56.18,
            47 : 57.22,
            47.5 : 57.57,
            48 : 58.62,
            48.5 : 58.97,
            49 : 60.02,
            49.5 : 60.37,
            50 : 61.42,
            50.5 : 61.77,
            51 : 62.81,
            51.5 : 63.16,
            52 : 64.21,
            52.5 : 64.56,
            53 : 65.61,
            53.5 : 65.96,
            54 : 67,
            54.5 : 67.35,
            55 : 68.4,
            55.5 : 68.75,
            56 : 69.8,
            56.5 : 70.15,
            57 : 71.19,
            57.5 : 71.54,
            58 : 72.59,
            58.5 : 72.94,
            59 : 73.99,
            59.5 : 74.34,
            60 : 75.39
        };
        const abdomen_table = {
            20 : 14.22,
            20.5 : 14.4,
            21 : 14.93,
            21.5 : 15.11,
            22 : 15.64,
            22.5 : 15.82,
            23 : 16.35,
            23.5 : 16.53,
            24 : 17.06,
            24.5 : 17.24,
            25 : 17.78,
            25.5 : 17.96,
            26 : 18.49,
            26.5 : 18.67,
            27 : 19.2,
            27.5 : 19.38,
            28 : 19.91,
            28.5 : 20.27,
            29 : 20.62,
            29.5 : 20.8,
            30 : 21.33,
            30.5 : 21.51,
            31 : 22.04,
            31.5 : 22.22,
            32 : 22.75,
            32.5 : 22.93,
            33 : 23.46,
            33.5 : 23.64,
            34 : 24.18,
            34.5 : 24.36,
            35 : 24.89,
            35.5 : 25.07,
            36 : 25.6,
            36.5 : 25.78,
            37 : 26.31,
            37.5 : 26.49,
            38 : 27.02,
            38.5 : 27.2,
            39 : 27.73,
            39.5 : 27.91,
            40 : 28.44,
            40.5 : 28.62,
            41 : 29.15,
            41.5 : 29.33,
            42 : 29.87,
            42.5 : 30.05,
            43 : 30.58,
            43.5 : 30.76,
            44 : 31.29,
            44.5 : 31.47,
            45 : 32,
            45.5 : 32.18,
            46 : 32.71,
            46.5 : 32.89,
            47 : 33.42,
            47.5 : 33.6,
            48 : 34.13,
            48.5 : 34.31,
            49 : 34.84,
            49.5 : 35.02,
            50 : 35.56
        };
        const height_table = {
            55 : 33.52,
            55.5 : 33.67,
            56 : 34.13,
            56.5 : 34.28,
            57 : 34.74,
            57.5 : 34.89,
            58 : 35.35,
            58.5 : 35.5,
            59 : 35.96,
            59.5 : 36.11,
            60 : 36.57,
            60.5 : 36.72,
            61 : 37.18,
            61.5 : 37.33,
            62 : 37.79,
            62.5 : 37.94,
            63 : 38.4,
            63.5 : 38.7,
            64 : 39.01,
            64.5 : 39.16,
            65 : 39.62,
            65.5 : 39.77,
            66 : 40.23,
            66.5 : 40.38,
            67 : 40.84,
            67.5 : 40.99,
            68 : 41.45,
            68.5 : 41.6,
            69 : 42.06,
            69.5 : 42.21,
            70 : 42.67,
            70.5 : 42.82,
            71 : 43.28,
            71.5 : 43.43,
            72 : 43.89,
            72.5 : 44.04,
            73 : 44.5,
            73.5 : 44.65,
            74 : 45.11,
            74.5 : 45.26,
            75 : 45.72,
            75.5 : 45.87,
            76 : 46.32

        };
    
        let retval = 0;
        if (hips_table[hips] !== undefined && abdomen_table[abdomen] !== undefined && height_table[height] !== undefined) {
            retval = Math.abs(hips_table[hips] + abdomen_table[abdomen] - height_table[height]);
        }
        
        return retval;
    }

    _getMaleBodyFatPercent(weight, waist_minus_wrist) {
        let retval=0;
        const waist_minus_wrists=[
            22,
            22.5,
            23,
            23.5,
            24,
            24.5,
            25,
            25.5,
            26,
            26.5,
            27,
            27.5,
            28,
            28.5,
            29,
            29.5,
            30,
            30.5,
            31,
            31.5,
            32,
            32.5,
            33,
            33.5,
            34,
            34.5,
            35,
            35.5,
            36,
            36.5,
            37,
            37.5,
            38,
            38.5,
            39,
            39.5,
            40,
            40.5,
            41,
            41.5,
            42,
            42.5,
            43,
            43.5,
            44,
            44.5,
            45,
            45.5,
            46,
            46.5,
            47,
            47.5,
            48,
            48.5,
            49,
            49.5,
            50
        ];

        const weights={ 120 : [4, 6, 8, 10, 12, 14, 16, 18, 20, 21, 23, 25, 27, 29, 31, 33, 35, 37, 39, 41, 43, 45, 47, 49, 50, 52, 54, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ],
            125 : [4, 6, 7, 9, 11, 13, 15, 17, 19, 20, 22, 24, 26, 28, 30, 32, 33, 35, 37, 39, 41, 43, 45, 46, 48, 50, 52, 54, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ],
            130 : [3, 5, 7, 9, 11, 12, 14, 16, 18, 20, 21, 23, 25, 27, 28, 30, 32, 34, 36, 37, 39, 41, 43, 44, 46, 48, 50, 52, 53, 55, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ],
            135 : [3, 5, 7, 8, 10, 12, 13, 15, 17, 19, 20, 22, 24, 26, 27, 29, 31, 32, 34, 36, 38, 39, 41, 43, 44, 46, 48, 50, 51, 53, 55, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ],
            140 : [3, 5, 6, 8, 10, 11, 13, 15, 16, 18, 19, 21, 23, 24, 26, 28, 29, 31, 33, 34, 36, 38, 39, 41, 43, 44, 46, 48, 49, 51, 53, 54, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ],
            145 : [0, 4, 6, 7, 9, 11, 12, 14, 15, 17, 19, 20, 22, 23, 25, 27, 28, 30, 31, 33, 35, 36, 38, 39, 41, 43, 44, 46, 47, 49, 51, 52, 54, 55, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ],
            150 : [0, 4, 6, 7, 9, 10, 12, 13, 15, 16, 18, 19, 21, 23, 24, 26, 27, 29, 30, 32, 33, 35, 36, 38, 40, 41, 43, 44, 46, 47, 49, 50, 52, 53, 55, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ],
            155 : [0, 4, 5, 6, 8, 10, 11, 13, 14, 16, 17, 19, 20, 22, 23, 25, 26, 28, 29, 31, 32, 34, 35, 37, 38, 40, 41, 43, 44, 46, 47, 49, 50, 52, 53, 55, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ],
            160 : [0, 4, 5, 6, 8, 9, 11, 12, 14, 15, 17, 18, 19, 21, 22, 24, 25, 27, 28, 30, 31, 33, 34, 35, 37, 38, 40, 41, 43, 44, 46, 47, 48, 50, 51, 53, 54, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ],
            165 : [0, 3, 5, 6, 8, 9, 10, 12, 13, 15, 16, 17, 19, 20, 22, 23, 24, 26, 27, 29, 30, 31, 33, 34, 36, 37, 38, 40, 41, 43, 44, 45, 47, 48, 50, 51, 52, 54, 55, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ],
            170 : [0, 3, 4, 6, 7, 9, 10, 11, 13, 14, 15, 17, 18, 19, 21, 22, 24, 25, 26, 28, 29, 30, 32, 33, 34, 36, 37, 39, 40, 41, 43, 44, 45, 47, 48, 49, 51, 52, 54, 55, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ],
            175 : [0, 0, 4, 6, 7, 8, 10, 11, 12, 13, 15, 16, 17, 19, 20, 21, 23, 24, 25, 27, 28, 29, 31, 32, 33, 35, 36, 37, 39, 40, 41, 43, 44, 45, 47, 48, 49, 51, 52, 53, 55, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ],
            180 : [0, 0, 4, 5, 7, 8, 9, 10, 12, 13, 14, 16, 17, 18, 19, 21, 22, 23, 25, 26, 27, 28, 30, 31, 32, 34, 35, 36, 37, 39, 40, 41, 43, 44, 45, 47, 48, 49, 50, 52, 53, 54, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ],
            185 : [0, 0, 4, 5, 6, 8, 9, 10, 11, 13, 14, 15, 16, 18, 19, 20, 21, 23, 24, 25, 26, 28, 29, 30, 31, 33, 34, 35, 36, 38, 39, 40, 41, 43, 44, 45, 46, 48, 49, 50, 51, 53, 54, 55, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ],
            190 : [0, 0, 4, 5, 6, 7, 8, 10, 11, 12, 13, 15, 16, 17, 18, 19, 21, 22, 23, 24, 26, 27, 28, 29, 30, 32, 33, 34, 35, 37, 38, 39, 40, 41, 43, 44, 45, 46, 48, 49, 50, 51, 52, 54, 55, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ],
            195 : [0, 0, 3, 5, 6, 7, 8, 9, 11, 12, 13, 14, 15, 16, 18, 19, 20, 21, 22, 24, 25, 26, 27, 28, 30, 31, 32, 33, 34, 36, 37, 38, 39, 40, 41, 43, 44, 45, 46, 47, 49, 50, 51, 52, 53, 55, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ],
            200 : [0, 0, 3, 4, 6, 7, 8, 9, 10, 11, 12, 14, 15, 16, 17, 18, 19, 21, 22, 23, 24, 25, 26, 28, 29, 30, 31, 32, 33, 35, 36, 37, 38, 39, 40, 41, 43, 44, 45, 46, 47, 48, 50, 51, 52, 53, 54, 55, 0, 0, 0, 0, 0, 0, 0, 0, 0 ],
            205 : [0, 0, 0, 4, 5, 6, 8, 9, 10, 11, 12, 13, 14, 15, 17, 18, 19, 20, 21, 22, 23, 25, 26, 27, 28, 29, 30, 31, 32, 34, 35, 36, 37, 38, 39, 40, 41, 43, 44, 45, 46, 47, 48, 49, 51, 52, 53, 54, 55, 0, 0, 0, 0, 0, 0, 0, 0 ],
            210 : [0, 0, 0, 4, 5, 6, 7, 8, 9, 11, 12, 13, 14, 15, 16, 17, 18, 19, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 32, 33, 34, 35, 36, 37, 38, 39, 40, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 53, 54, 55, 0, 0, 0, 0, 0, 0, 0 ],
            215 : [0, 0, 0, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 0, 0, 0, 0, 0 ],
            220 : [0, 0, 0, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 0, 0, 0, 0 ],
            225 : [0, 0, 0, 3, 4, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 31, 31, 32, 33, 34, 35, 36, 37, 38, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 0, 0, 0 ],
            230 : [0, 0, 0, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 44, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 0, 0 ],
            235 : [0, 0, 0, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 51, 52, 53, 54, 55 ],
            240 : [0, 0, 0, 0, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 46, 47, 48, 49, 50, 51, 52, 53, 54 ],
            245 : [0, 0, 0, 0, 4, 5, 6, 7, 8, 9, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53 ],
            250 : [0, 0, 0, 0, 4, 5, 6, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 44, 45, 46, 47, 48, 49, 50, 51, 52 ],
            255 : [0, 0, 0, 0, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 24, 25, 27, 27, 28, 29, 30, 31, 32, 33, 34, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 44, 45, 46, 47, 48, 49, 50, 51 ],
            260 : [0, 0, 0, 0, 3, 4, 5, 6, 7, 8, 9, 10, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 19, 20, 21, 22, 23, 24, 25, 26, 27, 27, 28, 29, 30, 31, 32, 33, 34, 35, 35, 36, 37, 38, 39, 40, 41, 42, 43, 43, 44, 45, 46, 47, 48, 49, 50 ],
            265 : [0, 0, 0, 0, 0, 4, 5, 6, 7, 8, 8, 9, 10, 11, 12, 13, 14, 15, 15, 16, 17, 18, 19, 20, 21, 22, 22, 23, 24, 25, 26, 27, 28, 29, 29, 30, 31, 32, 33, 34, 35, 36, 36, 37, 38, 39, 40, 41, 42, 43, 43, 44, 45, 46, 47, 48, 49 ],
            270 : [0, 0, 0, 0, 0, 4, 5, 6, 7, 7, 8, 9, 10, 11, 12, 13, 13, 14, 15, 16, 17, 18, 19, 19, 20, 21, 22, 23, 24, 25, 25, 26, 27, 28, 29, 30, 31, 31, 32, 33, 34, 35, 36, 37, 37, 38, 39, 40, 41, 42, 43, 43, 44, 45, 46, 47, 48 ],
            275 : [0, 0, 0, 0, 0, 4, 5, 5, 6, 7, 8, 9, 10, 11, 11, 12, 13, 14, 15, 16, 16, 17, 18, 19, 20, 21, 22, 22, 23, 24, 25, 26, 27, 27, 28, 29, 30, 31, 32, 32, 33, 34, 35, 36, 37, 38, 38, 39, 40, 41, 42, 43, 43, 44, 45, 46, 47 ],
            280 : [0, 0, 0, 0, 0, 4, 4, 5, 6, 7, 8, 9, 9, 10, 11, 12, 13, 14, 14, 15, 16, 17, 18, 19, 19, 20, 21, 22, 23, 24, 24, 25, 26, 27, 28, 29, 29, 30, 31, 32, 33, 33, 34, 35, 36, 37, 38, 38, 39, 40, 41, 42, 43, 43, 44, 45, 46 ],
            285 : [0, 0, 0, 0, 0, 4, 4, 5, 6, 7, 8, 8, 9, 10, 11, 12, 12, 13, 14, 15, 16, 17, 17, 18, 19, 20, 21, 21, 22, 23, 24, 25, 26, 26, 27, 28, 29, 30, 30, 31, 32, 33, 34, 34, 35, 36, 37, 38, 39, 39, 40, 41, 42, 43, 43, 44, 45 ],
            290 : [0, 0, 0, 0, 0, 3, 4, 5, 6, 7, 7, 8, 9, 10, 11, 11, 12, 13, 14, 15, 15, 16, 17, 18, 19, 19, 20, 21, 22, 23, 23, 24, 25, 26, 27, 27, 28, 29, 30, 31, 31, 32, 33, 34, 35, 35, 36, 37, 38, 39, 39, 40, 41, 42, 43, 43, 44 ],
            295 : [0, 0, 0, 0, 0, 3, 4, 5, 6, 6, 7, 8, 9, 10, 10, 11, 12, 13, 14, 14, 15, 16, 17, 17, 18, 19, 20, 21, 21, 22, 23, 24, 25, 25, 26, 27, 28, 28, 29, 30, 31, 32, 32, 44, 34, 35, 36, 36, 37, 38, 39, 39, 40, 41, 42, 43, 43 ],
            300 : [0, 0, 0, 0, 0, 3, 4, 5, 5, 6, 7, 8, 9, 9, 10, 11, 12, 12, 13, 14, 15, 16, 16, 17, 18, 19, 19, 20, 21, 22, 22, 23, 24, 25, 26, 26, 27, 28, 29, 29, 30, 31, 32, 44, 33, 34, 35, 36, 36, 37, 38, 39, 39, 40, 41, 42, 43 ]
        };

        if (weights.hasOwnProperty(weight)) {
            let element_index = waist_minus_wrists.indexOf(waist_minus_wrist);
            if (element_index !== -1 && weights[weight].hasOwnProperty(element_index)) {
              return weights[weight][element_index];
            }
        }
        return retval;
    }

    _checkValidation=()=>{
        this.form.querySelectorAll('input:invalid').forEach(ele => {
            ele.classList.remove('border-danger')
        });
        this.form.querySelectorAll('input:invalid').forEach(ele => {
            ele.classList.add('border-danger')
        });
    }
}
customElements.define('body-fat-calculator', bodyFatCal);